import React, { useEffect, useState } from 'react';
import { useI18n } from '../i18n';

export const SW_UPDATE_EVENT = 'dojo-mojo-sw-update';

// Shown when a new version has been downloaded and is waiting to take over.
export default function UpdateBanner() {
  const { t } = useI18n();
  const [registration, setRegistration] = useState(null);

  useEffect(() => {
    const onUpdate = (event) => setRegistration(event.detail);
    window.addEventListener(SW_UPDATE_EVENT, onUpdate);
    return () => window.removeEventListener(SW_UPDATE_EVENT, onUpdate);
  }, []);

  if (!registration) return null;

  const aplicar = () => {
    const waiting = registration.waiting;
    if (!waiting) {
      window.location.reload();
      return;
    }
    navigator.serviceWorker.addEventListener('controllerchange', () => window.location.reload(), { once: true });
    waiting.postMessage({ type: 'SKIP_WAITING' });
  };

  return (
    <div role="status" className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[80] max-w-md w-[calc(100%-2rem)] bg-gray-900 text-white px-4 py-3 rounded-lg shadow-pop flex items-center justify-between gap-3 text-sm">
      <span>{t('update.available')}</span>
      <button onClick={aplicar} className="bg-white hover:bg-gray-100 text-gray-900 h-8 px-3 rounded-md text-xs font-semibold flex-shrink-0">
        {t('update.reload')}
      </button>
    </div>
  );
}
